import { render, staticRenderFns } from "./CourtsMap.vue?vue&type=template&id=65e5099a"
import script from "./CourtsMap.vue?vue&type=script&lang=js"
export * from "./CourtsMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports